import { AssetTypes } from "constant/AssetTypes";
import { RouteName } from "constant/routeNames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { removeAllPlayer } from "redux/AudioPlayerRedux";
import {
  removeLiveTVData,
  setVideoStart,
  setVideoSuccess,
  setVideoLoaded,
} from "redux/VideoPlayerRedux";
import VideoService from "services/video/VideoService";
import { getLastWatchTime } from "utils/timeFunctions";
import CommonPlayerSection from "./shared/CommonPlayerSection";
import { ContentTypes } from "constant/ContentTypes";

function VideoTVSeriesPlayerPage() {
  const { slug, stream } = useParams();
  const navigate = useNavigate();
  const [openGeoLoactionModel, setOpenGeoLoactionModel] = useState(false);

  const dispatch = useDispatch<any>();
  const [videoDetails, setVideoDetails] = useState<any>({});
  const [error, setError] = useState("");
  const { lastWatched } = useSelector((state: any) => state?.video);

  const location = useLocation();
  const { currentTime } = location.state || {};
  // console.log("currentTime: ", currentTime);

  useEffect(() => {
    let cleanedSlug = slug && slug.endsWith(".html") ? slug.slice(0, -5) : slug;
    dispatch(removeLiveTVData());
    dispatch(removeAllPlayer());
    setVideoDetails({});
    const loadData = async () => {
      dispatch(setVideoStart());
      setTimeout(async () => {
        await VideoService.getTVSeriesDetailsBySlug(cleanedSlug)
          .then(async (series) => {
            if (series?.data?.allowed_to_watch === false) {
              setOpenGeoLoactionModel(true);
            }
            const res = await VideoService.getTVSeriesByStreamKey(stream);
            const episode = res.data?.data ?? res.data; // handle both shapes

            let lastWatchTime = 0;
            try {
              const lastWatch = await VideoService.getLastWatchTimeByContentId(
                episode.id,
                ContentTypes.TV_SERIES,
              );
              if (lastWatch?.status === 200 && lastWatch?.data?.data !== null) {
                lastWatchTime = lastWatch?.data.data.currentTime;
              } else {
                const lastWatchedItem = lastWatched.find(
                  (item: any) =>
                    item.content_id === episode.id &&
                    item.content_type === AssetTypes.TVSeries,
                );
                if (lastWatchedItem)
                  lastWatchTime = lastWatchedItem.currentTime;
              }
            } catch {
              // last-watch is non-critical — never 404 because of it
            }

            const value = {
              ...episode,
              tv_series_id: episode?.tv_show_id,
              season: episode?.season_id,
              userCurrentTime: lastWatchTime,
              poster: episode?.thumbnail,
            };
            setVideoDetails({
              ...value,
              ...series.data,
              slug: cleanedSlug,
              plan_id: series.data?.plan_id,
            });
            dispatch(setVideoSuccess(value));
            setError("");
            dispatch(setVideoLoaded());
          })
          .catch(() => {
            toast.error("Content Not Found");
            setError("Content Not Found, Please try again");
            navigate(RouteName.pageNotFound);
            dispatch(setVideoLoaded());
          });
      }, 1000);

    };
    loadData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, stream]);
  return (
    <>
      <CommonPlayerSection
        videoDetails={videoDetails}
        contentType="series"
        openGeoLoactionModel={openGeoLoactionModel}
        setOpenGeoLoactionModel={setOpenGeoLoactionModel}
        error={error}
        currentTime={currentTime}
      />
    </>
  );
}

export default VideoTVSeriesPlayerPage;
